import Contact from './Contact';

export default Contact;



// WEBPACK FOOTER //
// ./src/pages/static/Contact/index.jsx